import React from 'react';

interface Props {
  option: string;
  displayName: string;
  handleAddSelected: (option: string) => void;
}

const AssigneeItem: React.FC<Props> = (props: Props) => {
  const { option, displayName, handleAddSelected } = props;

  return (
    <>
      <div
        className="bb-2 row items-center px4 cursor-pointer"
        style={{
          height: '44px',
        }}
        onClick={() => handleAddSelected(option)}
      >
        {displayName}
      </div>
    </>
  );
};
export default AssigneeItem;
